<template>
    <div class="richMenu__option" :class="getClass()" :data-icoTarget="getIcon()" @click.stop="$emit('click')">
        <i class="check" v-if="!logout && !add"></i>
        <div class="name">{{ name }}</div>
        <i class="icoButton" data-icoTarget v-if="!logout && !add" @click.stop="$emit('clickAction')"></i>

        <div class="richMenu__edition" @click.stop.prevent>
            <slot name="inputs"></slot>
            <!-- <div class="c-formItem">
                <label class="c-formLabel" for="">Nombre</label>
                <input class="c-formInput" type="text" name="" placeholder="" />
            </div>
            <div class="c-formItem">
                <label class="c-formLabel" for="">Tipo de ubicación</label>
                <select class="c-formSelect">
                    <option selected>Casa</option>
                    <option>Oficina</option>
                    <option>Hotel</option>
                    <option>Fabrica</option>
                </select>
            </div> -->
            <div class="richMenu__actions">
                <a class="btn btn--simple" v-if="showDelete" @click.stop.prevent="$emit('deleteClick')">{{
                    deleteText
                }}</a>
                <a class="btn btn--simple" @click.stop.prevent="$emit('cancelClick')">{{ cancelText }}</a>
                <a class="btn btn--simple" @click.stop.prevent="$emit('acceptClick')">{{ acceptText }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ui-RichMenuOption',
        props: {
            name: {
                type: String,
                default: 'Option',
            },
            icono: {
                type: String,
                default: 'saveSpace',
            },
            active: {
                type: Boolean,
                default: false,
            },
            edition: {
                type: Boolean,
                default: false,
            },
            acceptText: String,
            deleteText: String,
            cancelText: String,
            logout: {
                type: Boolean,
                default: false,
            },
            add: {
                type: Boolean,
                default: false,
            },
            showDelete: {
                type: Boolean,
                default: true,
            },
        },
        methods: {
            getClass: function() {
                var classStyles = '';

                if (this.active) classStyles = `${classStyles} richMenu__option--active`;
                if (this.edition) classStyles = `${classStyles} richMenu__option--edition`;
                if (this.logout) classStyles = `${classStyles} richMenu__option--logOut`;
                if (this.add) classStyles = `${classStyles} richMenu__option--add`;

                return classStyles;
            },
            getIcon: function() {
                var icoTarget = this.icono;
                if (this.add) icoTarget = 'add';
                if (this.logout) icoTarget = '';

                return icoTarget;
            },
            click: function() {
                var icoTarget = this.icono;
                if (this.add) icoTarget = 'add';
                if (this.logout) icoTarget = '';

                return icoTarget;
            },
            clickActions: function() {
                var icoTarget = this.icono;
                if (this.add) icoTarget = 'add';
                if (this.logout) icoTarget = '';

                return icoTarget;
            },
        },
    };
</script>
